import React from "react";
import {SpeedDial, SpeedDialItem} from "react-mui-speeddial";
import {addUserCampaign, removeUserFromCampaign} from "../../../lib/user";
// just some icons for illustration (example only):
import ContentAdd from "material-ui/svg-icons/content/add";
import NavigationClose from "material-ui/svg-icons/navigation/close";
import SuperVisorAccount from "material-ui/svg-icons/action/supervisor-account";
import LockOpen from "material-ui/svg-icons/action/lock-open";
import LockOutline from "material-ui/svg-icons/action/lock-outline";
import firebase from "firebase";
import Forum from "material-ui/svg-icons/communication/forum";
import FloatingActionButton from "material-ui/FloatingActionButton";
import "./Menu.css";
import store from "../../../lib/store";

export default class Menu extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            AuthDialogProps:{
                open:false
            }
        }
    }

    render(){
        if(this.props.isLogined === null){
            return <div style={{display:'none'}} />
        }
        return (
            <div className="SpeedDialMenu">
                <SpeedDial
                    fabContentOpen={
                        <ContentAdd />
                    }
                    fabContentClose={
                        <NavigationClose />
                    }
                >
                    {this.generateLoginBtn.bind(this)()}
                    {this.generateRegisterBtn.bind(this)()}
                </SpeedDial>
                <FloatingActionButton mini={true} onTouchTap={function(){
                    store.dispatch({type:'LIVE_OPEN', liveMode:'live'});
                }} style={{
                    position: 'absolute',
                    right: '69px',
                    bottom: '6px'
                }}>
                    <Forum/>
                </FloatingActionButton>
            </div>
        );
    }

    loginAndExecute(callback) {
        var unsubscribe = firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                callback();
            } else {
                this.setState({AuthDialogProps:{open:true}});
            }
            unsubscribe();
        }.bind(this));
    }

    participateHandler(event){
        if(firebase.auth().currentUser === null){
            store.dispatch({
                type:'LOGIN',
                loginOpen:'true',
                loginAfterExecute:function(){
                    addUserCampaign(
                        firebase.auth().currentUser,
                        this.props.campaignId,
                        function(){
                            window.location.reload();
                        }
                    );
                }.bind(this)
            })
        } else {
            addUserCampaign(
                firebase.auth().currentUser,
                this.props.campaignId,
                function(){
                    window.location.reload();
                }
            );
        }

    }

    unParticipateHandler(event){
        this.loginAndExecute(function(){
            let uid = firebase.auth().currentUser.uid;
            if(!uid || uid === ''){
                return;
            }
            firebase.database().ref(`/campaign/${this.props.campaignId}/users/${uid}`).once('value', function(sp){
                if(sp.exists()){
                    if(window.confirm('정말 참가 취소를 합니까? 취소하면 현재 캠페인의 모든 정보가 삭제됩니다. 회원탈퇴는 되지 않습니다.')){
                        removeUserFromCampaign(
                            firebase.auth().currentUser.uid,
                            this.props.campaignId,
                            function(){
                                window.location.reload();
                            }
                        );
                    }
                }
            }.bind(this));
        }.bind(this));
    }

    loginHandler(event){
        store.dispatch({
            type:'LOGIN',
            loginOpen:true,
            loginAfterExecute:function(){
                window.location.reload();
            }
        })
    }

    logoutHandler(event){
        firebase.auth().signOut().then(function(){
            window.location.reload();
        });
    }

    openLiveHandler(event){
        this.setState({LivDialogProps:{open:true}});
    };

    generateLoginBtn() {
        let loginBtn;
        let display = this.props.isLogined === null ? 'none' : 'block';
        if (this.props.isLogined === true) {
            loginBtn = (
                <SpeedDialItem
                    style={{display}}
                    label="로그아웃"
                    fabContent={<LockOutline/>}
                    onTouchTap={this.logoutHandler.bind(this)}
                />
            );
        } else {
            loginBtn = (
                <SpeedDialItem
                    style={{display}}
                    label="로그인"
                    fabContent={<LockOpen/>}
                    onTouchTap={this.loginHandler.bind(this)}
                />
            );
        }
        return loginBtn;
    }

    generateRegisterBtn() {
        let registerBtn;
        let display = this.props.isRegistered === null ? 'none' : 'block';
        if (this.props.isRegistered === true) {
            registerBtn = (
                <SpeedDialItem
                    style={{display:display}}
                    label="참가취소"
                    fabContent={<SuperVisorAccount/>}
                    onTouchTap={this.unParticipateHandler.bind(this)}
                />
            );
        } else {
            registerBtn = (
                <SpeedDialItem
                    style={{display:display}}
                    label="참가하기"
                    fabContent={<SuperVisorAccount/>}
                    onTouchTap={this.participateHandler.bind(this)}
                />
            );
        }
        return registerBtn;
    }
}




// WEBPACK FOOTER //
// ./src/container/campaign/component/Menu.js